import actionTypes from './actionTypes';
import update from 'immutability-helper';

export const initialState = {
  basics: {},
  conditions: [],
  interests: [],
  isLoading: true,
};

export default function Reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_PROFILE:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_PROFILE_SUCCESS:
      const { basics, conditions, interests } = action.data;
      return {
        ...state,
        basics,
        conditions,
        interests,
        isLoading: false,
      };
    case actionTypes.UPDATE_PROFILE_BASICS_SUCCESS:
      return {
        ...state,
        basics: action.data,
      };
    case actionTypes.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        basics: action.data.basics,
        conditions: action.data.conditions,
        interests: action.data.interests,
      };
    case actionTypes.DELETE_PROFILE_CONDITION_SUCCESS:
      return update(state, {
        conditions: {
          $set: state.conditions.filter(x => x.id !== action.id),
        },
      });
    case actionTypes.DELETE_PROFILE_INTEREST_SUCCESS:
      return update(state, {
        interests: {
          $set: state.interests.filter(x => x.id !== action.id),
        },
      });
    case actionTypes.ADD_PROFILE_INTERESTS_SUCCESS:
      return update(state, {
        interests: {
          $set: action.interests,
        },
      });
    case actionTypes.UPDATE_PROFILE_INTEREST_PRIVACY_SUCCESS:
      const interest = state.interests.find(x => x.id === action.interest.id);
      return update(state, {
        interests: {
          [state.interests.indexOf(interest)]: { isPrivate: { $set: action.interest.isPrivate } },
        },
      });
    case actionTypes.UPDATE_PROFILE_CONDITION_SUCCESS:
      const condition = state.conditions.find(x => x.id === action.condition.id);
      return update(state, {
        conditions: {
          [state.conditions.indexOf(condition)]: {
            diagnosisDate: { $set: action.condition.diagnosisDate },
            isPrivate: { $set: action.condition.isPrivate },
            selectedConditionReason: { $set: action.condition.selectedConditionReason },
          },
        },
      });
    case actionTypes.UPDATE_PROFILE_BIO_SUCCESS:
      return update(state, {
        basics: {
          aboutMe: { $set: action.bio },
        },
      });
  }
  return state;
}
